import type { Stakeholders } from './types.tsx';

export const EMPTY_STAKEHOLDERS: Stakeholders = {
	users: [],
	groups: [],
};
